module.exports = __webpack_public_path__ + "img/DesktopApp.6022b165.svg";